module.exports = __webpack_public_path__ + "assets/webgl/card_109_DE_L0.jpg.55fd860e.webp";